import { ENABLE_OPTION_FLOW_READ_MODE } from 'utils/shared/trades/optionFlowRead';
import { ColumnType } from 'utils/shared/trades/types';

export const DEFAULT_FLOW_KEY_INDEX = 0;
export const FLOW_TABLE_HEADERS = [
  { name: 'Time', sortKey: 'createdAt', columnType: ColumnType.Date },
  { name: 'Ticker', sortKey: 'ticker', columnType: ColumnType.Text },
  { name: 'C/P', sortKey: 'cp', columnType: ColumnType.Text },
  { name: 'Side', sortKey: 'tradeDirection', columnType: ColumnType.Text },
  { name: 'Read', sortKey: 'sideRead', columnType: ColumnType.Text },
  { name: 'Expiry', sortKey: 'expiry', columnType: ColumnType.Date },
  { name: 'Spot', sortKey: 'spot', columnType: ColumnType.Number },
  { name: 'Strike', sortKey: 'strike', columnType: ColumnType.Number },
  { name: 'OTM', sortKey: 'otmPercent', columnType: ColumnType.Number },
  { name: 'Price', sortKey: 'price', columnType: ColumnType.Number },
  { name: 'Size', sortKey: 'size', columnType: ColumnType.Number },
  { name: 'Open Interest', sortKey: 'openInterest', columnType: ColumnType.Number },
  { name: 'Implied Vol', sortKey: 'impliedVol', columnType: ColumnType.Number },
  { name: 'Type', sortKey: 'orderType', columnType: ColumnType.Text },
  { name: 'Premium', sortKey: 'premium', columnType: ColumnType.Number },
  { name: 'Sector', sortKey: 'sector', columnType: ColumnType.Text },
  { name: 'Heat Score', sortKey: 'heatScore', columnType: ColumnType.Number },
  { name: '', sortKey: 'actions', columnType: ColumnType.Text },
].filter((header) => ENABLE_OPTION_FLOW_READ_MODE || header.name !== 'Read');
export const DEFAULT_FLOW_KEY = FLOW_TABLE_HEADERS[DEFAULT_FLOW_KEY_INDEX].sortKey;
